<template>
    <div class="card">
        <div class="card-content">
            <div class="content">
                <h3>Device Information</h3>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: "MacSearchSettings"
};

</script>

<style scoped>

</style>